<div class="buttons-bar">
  <button mat-icon-button color="primary" class="negative-margin" (click)="onResizeModal()" [disabled]="saveInProgress">
    <mat-icon>{{ isFullScreen ? "close_fullscreen" : "open_in_full" }}</mat-icon>
  </button>
  <button
    mat-icon-button
    color="warn"
    class="negative-margin"
    matTooltip="{{ 'btn.close' | translate }}"
    (click)="dialog.closeAll()"
    [disabled]="saveInProgress"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <mat-accordion>
    <mat-expansion-panel [expanded]="true || forceExpandQuestionnaire">
      <mat-expansion-panel-header>
        <mat-panel-title class="accordeonTitle"> {{ questionnaireResponse?.group.text ?? questionnaire?.subjectType }} </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="answerNewQr">
        <div *ngIf="isUpdate && !slideViews.length">
          {{ "model.patient.questionnaireNotAvailable" | translate : { lang: lang } }}
        </div>
        <ng-container *ngIf="questionnaireResponse?.group.text && questionnaireResponse?.group.text.length > 0">
          <p class="title">{{ questionnaireResponse?.group.title }}</p>
        </ng-container>

        <!-- Only 1 slide : No need for stepper -->
        <div *ngIf="slideViews.length === 1">
          <ng-container *ngTemplateOutlet="singleStepContent; context: { slide: slideViews[0] }"></ng-container>
        </div>

        <!-- More than 1 slide : Use stepper -->
        <mat-horizontal-stepper *ngIf="slideViews.length > 1" linear #stepper class="stepper" labelPosition="bottom">
          <mat-step *ngFor="let slide of slideViews">
            <div *ngFor="let contentGroup of slide.content">
              <ng-template matStepLabel>{{ contentGroup.title }}</ng-template>
              <p style="text-align: center">{{ contentGroup.description }}</p>
              <ng-container *ngTemplateOutlet="cardRendering; context: { contentGroup: contentGroup }"></ng-container>
            </div>
            <div class="action-container">
              <button mat-button matStepperPrevious *ngIf="!isFirst && slideViews.length > 1">
                {{ "btn.back" | translate }}
              </button>
              <span *ngIf="isFirst && slideViews.length > 1"></span>
              <button mat-button matStepperNext *ngIf="!isLast && slideViews.length > 1">
                {{ "btn.next" | translate }}
              </button>
            </div>
          </mat-step>
        </mat-horizontal-stepper>

        <!-- Template for single step (no stepper) -->
        <ng-template #singleStepContent let-slide="slide">
          <div *ngFor="let contentGroup of slide.content">
            <p style="font-weight: 500; padding-left: 24px">{{ contentGroup.title }}</p>
            <p style="text-align: center">{{ contentGroup.description }}</p>
            <ng-container *ngTemplateOutlet="cardRendering; context: { contentGroup: contentGroup }"></ng-container>
          </div>
        </ng-template>

        <!-- Shared card rendering template -->
        <ng-template #cardRendering let-contentGroup="contentGroup">
          <div class="card-container">
            <ng-container *ngFor="let questionResponse of contentGroup.questionResponses; let i = index">
              <app-encode-question
                [ngStyle]="questionResponse.question.type === INPUT_TYPE.TEXTFIELD_HTML ? { width: '100%' } : { width: 'fit-content' }"
                *ngIf="questionResponse.question | isQuestionEnabled : questionnaireResponse"
                [question]="questionResponse.question"
                [(response)]="questionResponse.response"
                [questionnaire]="questionnaire"
                [questionnaireResponse]="questionnaireResponse"
                [hasValidate]="hasValidate"
                [index]="i"
                (inputChange)="onInputChange()"
              ></app-encode-question>
            </ng-container>
          </div>
        </ng-template>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="linkedObservationsDef?.length" [expanded]="forceExpandObservations">
      <mat-expansion-panel-header>
        <mat-panel-title class="accordeonTitle"> {{ "observation.title" | translate }} </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="answerNewQr" *ngIf="patientConfig">
        <app-encode-observations
          [_existingObservations]="linkedObservations"
          [observationsDefinitions]="linkedObservationsDef"
          [patientReference]="data.patientRef"
          [questionnaireIdentifier]="questionnaire.identifier[0].value"
          [disabled]="false"
          [vitalProfile]="data.pu.user.vitalProfile ?? []"
          [notificationSettings]="patientConfig.settings?.notificationSettings"
          (newObservationsChange)="linkedObservationsChanged($event)"
        ></app-encode-observations>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <mat-form-field *ngIf="questionnaire.completionDateEditable">
    <mat-label>{{ "table.date" | translate }}</mat-label>
    <input matInput [matDatepicker]="startDate" [placeholder]="'table.date' | translate" [(ngModel)]="completionDate" [max]="maxDate" />
    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
    <mat-datepicker #startDate></mat-datepicker>
  </mat-form-field>
  <p *ngIf="lastSavedTime">{{ "communication.lastSaveAt" | translate }} : {{ lastSavedTime }}</p>
  <button
    mat-button
    (click)="complete()"
    [disabled]="saveInProgress"
    *ngIf="isLast || slideViews.length === 1 || linkedObservations?.length || linkedObservationsDef?.length"
  >
    {{ "common.finish" | translate }}
  </button>
  <button mat-button (click)="saveProgress()" [disabled]="saveInProgress">
    {{ "common.save" | translate }}
  </button>
  <mat-checkbox
    matTooltip="{{ 'page.questionnaireEditor.properties.autoSaveTooltip' | translate }}"
    (change)="$event.checked ? saveProgress() : {}"
    [disabled]="!questionnaire._id"
    [(ngModel)]="autoSaveActivated"
  >
    {{ "page.questionnaireEditor.properties.autoSave" | translate }}
  </mat-checkbox>
</mat-dialog-actions>
